import { createRoutine } from 'app/common/utils/new-routines';
import type { ProjectSchemaCompat } from 'app/compat/types';
import type { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { getSchemaVersion } from '../api';

export type GetSchemaVersionRequest = {
  version: number;
};

export type GetSchemaVersionResponse = {
  status: 'Schema found' | 'Schema not found';
  schema: ProjectSchemaCompat;
};

export const getSchemaVersionRoutine = createRoutine('schema/GET_SCHEMA_VERSION')<
  undefined,
  GetSchemaVersionRequest,
  undefined,
  GetSchemaVersionResponse,
  string,
  undefined
>();

export function* getSchemaVersionSaga(payload: GetSchemaVersionRequest): SagaIterator {
  const schemaVersion: GetSchemaVersionResponse = yield call(getSchemaVersion, payload);
  const { schema } = schemaVersion;
  return schema;
}
